const zh = {
  home: {
    heroTitle: '韩漫漫画大全',
    heroSubtitle: '精选好看的韩漫推荐，免费韩漫漫画全集在线观看',
    heroCta: '开始阅读',
    heroBrowse: '浏览分类',
    hotTitle: '热门推荐',
    hotSubtitle: '大家都在看的韩漫精选',
    latestTitle: '最近更新',
    latestSubtitle: '最新章节第一时间上线',
    rankingTitle: '人气排行',
    rankingSubtitle: '最受欢迎的韩漫作品',
    categoryTitle: '漫画分类',
    categorySubtitle: '按类型找到你喜欢的漫画',
    viewAll: '查看全部',
    readNow: '立即阅读',
    statusOngoing: '连载中',
    statusCompleted: '已完结',
    chapters: '话',
    views: '次观看',
    rating: '分',
    updatedAt: '更新于',
    footerBrand: '韩漫网 - 您的韩漫阅读首选平台',
  },
  category: {
    title: '分类浏览',
    allCategories: '全部分类',
    filterByStatus: '按状态筛选',
    all: '全部',
    ongoing: '连载中',
    completed: '已完结',
    sortBy: '排序',
    sortLatest: '最新更新',
    sortPopular: '最受欢迎',
    sortRating: '评分最高',
    noResults: '该分类下暂无漫画',
    resultCount: '共 {{count}} 部作品',
  },
  comic: {
    chapters: '章节列表',
    chapterCount: '共 {{count}} 话',
    author: '作者',
    status: '状态',
    category: '分类',
    tags: '标签',
    views: '阅读量',
    rating: '评分',
    summary: '作品简介',
    startReading: '开始阅读',
    readNow: '立即阅读',
    relatedTitle: '相关推荐',
    updatedAt: '最后更新',
  },
  about: {
    title: '关于韩漫网',
    brandIntro: '品牌介绍',
    brandDesc: '韩漫网成立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为中文读者提供最新、最全、最优质的韩漫资源，让每一位漫画爱好者都能在这里找到心仪的作品。',
    reputation: '用户口碑',
    contactTitle: '联系我们',
    contactDesc: '如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系。我们的团队将在24小时内回复您的消息。',
    email: '电子邮箱',
    features: '平台特色',
    faqTitle: '常见问题',
  },
  common: {
    home: '首页',
    category: '分类',
    about: '关于我们',
    search: '搜索漫画...',
    prev: '上一页',
    next: '下一页',
    backToHome: '返回首页',
    pageNotFound: '页面未找到',
    notFoundDesc: '您访问的页面不存在或已被移除',
  },
};

export default zh;